module.exports = __webpack_public_path__ + "static/hero_img-cecc36c581be8533a8b755b7ec72cd9e.jpg";